import React, { useEffect, useState } from "react";
import "./moredetails.css";
import { Row, Col, Container } from "react-bootstrap";
import { getLastPage } from "../api/core";
import { useTranslation } from "react-i18next";

const MoreDetails = (props) => {
  const { t } = useTranslation(["translation"]);
  const [seasonVal, setSeasonVal] = useState([]);

  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  useEffect(() => {
    const FullPageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getLastPage(app, id).then(
        (result) => {
          setSeasonVal(result.data);
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    FullPageDetail(
      props.match.params.AppId,
      props.match.params.videoId ? props.match.params.videoId : props.detail._id
    );
    isLoading(false);
  }, [props.match.params.videoId, props.match.params.AppId, props.detail._id]);

  if (!loading && !error) {
    return (
      <Container>
        <Row>
          <Col sm={12}>
            <div className="play-details-content">
              <div className="title-block d-flex align-items-center justify-content-between">
                <h2 className="play-title">{t("label_Synopsis")}</h2>
              </div>
              {/* Title Block */}
              <div className="details-desc">
                <p>{seasonVal.description}</p>
              </div>
              {/* Details Desc */}
              <div className="movie-persons mb-4">
                <div className="person-block">
                  <h5 className="title">{t("label_Director")}</h5>
                  <p className="name">{seasonVal.director}</p>
                </div>
                {/* Person Block */}
                <div className="person-block">
                  <h5 className="title">{t("label_Producer")}</h5>
                  <p>{seasonVal.producer}</p>
                </div>
                {/* Person Block */}
              </div>
              {/* Movie Persons */}
              <div className="movie-persons mb-4">
                <div className="person-block">
                  <h5 className="title">{t("label_Studio")}</h5>
                  <p className="name">{seasonVal.studio}</p>
                </div>
                {/* Person Block */}
                <div className="person-block">
                  <h5 className="title">{t("label_Written_By")}</h5>
                  <p>{seasonVal.writer}</p>
                </div>
                {/* Person Block */}
              </div>
              {/* Movie Persons */}

              {/* Details Buttons End */}
            </div>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return <div></div>;
  }
};

export default MoreDetails;
